<template>
    <span class="modal-container">
        <span data-balloon="Leave Project" data-balloon-pos="up">
            <button class="share simple" @click="open"><i class="fa fa-sign-out"></i></button>
        </span>
        <div class="remodal" :data-remodal-id="modalID">
            <div class="modal">
                <div>
                    <h3>Leave project</h3>
                    <p>
                        Project <strong v-text="title"></strong> has been shared with you by <strong v-text="ownerName"></strong>. <br>
                        Click the button below to leave this project.
                    </p>

                    <p v-if="error" class="error" v-text="error" v-cloak></p>
                    <p v-if="success" class="success" v-text="success" v-cloak></p>

                    <div class="submit" v-if="!hasSuccess">
                        <button type="submit" @click="removeMe()">Remove Me from the Project</button>
                    </div>
                    <p class="warning" v-if="!hasMessage">
                        This action cannot be undone.
                    </p>
                </div>
            </div>
            <button data-remodal-action="close" class="remodal-close simple"></button>
        </div>
    </span>
</template>

<script>
    import axios from 'axios';
    import Modal from 'vue/common/_modal';
    import {mapActions} from 'vuex'

    export default {
        data(){
            return {
                error: null,
                success: null,
            }
        },
        computed: {
            modalID() {
                return `${this.id}-leave`
            },
            hasMessage() {
                if (this.error || this.success) {
                    return true;
                }
                return false;
            },
            hasSuccess() {
                if (this.success) {
                    return true;
                }
                return false;
            }
        },
        methods: {
            setMessage(type, message) {
                if (type == 'error') {
                    this.error = message;
                }
                if (type == 'success') {
                    this.success = message;
                }

                setTimeout(() => this.clearMessages(), 8000);
            },
            clearMessages() {
                this.error = null;
                this.success = null;
            },
            removeMe() {
                this.clearMessages();

                var _self = this;

                let form = new FormData();
                form.append('project_id', this.id);
                form.append('user_id', this.userId);
                form.append('user_email', this.userEmail);

                axios({
                    method: 'post',
                    url: '/actions/anvil-module/project/unshare-project',
                    data: form
                })
                .then(response => {
                    //console.log(response.data);
                    window.location.reload();
                    //_self.setMessage('success', response.data.success);
                })
                .catch(error => {
                    //console.log(error.response);
                    _self.setMessage('error', error.response.data);
                });
            }
        },
        extends: Modal,
        mounted() {
        },
        props: {
            id: {
                type: String
            },
            title: {
                type: String
            },
            userId: {
                type: String
            },
            userEmail: {
                type: String
            },
            ownerName: {
                type: String
            }
        }
    }
</script>